// @flow
export function hideMap(): void {
  const map = document.getElementById('map')
  if (map) {
    map.style.display = 'none'
  }
}